import { MoveStates } from '../constants';
import type { ReorganizationPostEdge } from '../useTopicReorganization';

const isReorganizationPostEdgePinned = ({
  pinnedOrder,
  reorganizationMetadata: { move, isPinned },
}: ReorganizationPostEdge) => {
  return move?.state !== MoveStates.movedOut && typeof isPinned === 'boolean'
    ? isPinned
    : pinnedOrder != null;
};

export default isReorganizationPostEdgePinned;
